import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    budgets: [],
    status: null
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    listBO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budgetMovement
        .listBO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    listTaxo({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budgetMovement
        .listTaxo(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    addBudget({ commit }, body) {
      commit(mutations.LOADING);
      return api.budgetMovement
        .addBudget(body)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error.response;
        });
    },
    transferBudget({ commit }, body) {
      commit(mutations.LOADING);
      return api.budgetMovement
        .transferBudget(body)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error.response;
        });
    },
    history({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budgetMovement
        .history(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    }
  },
  getters: {}
};
